import { Component } from "react";
import { withRouter } from "react-router";

import './style.scss';

class Modal extends Component {
    componentDidMount() {
        if (!this.props.relative) document.body.style.overflow = "hidden";
    }

    componentWillUnmount() {
        if (!this.props.relative) document.body.style.overflow = "";
    }

    close = () => {
        if (!this.props.relative) this.props.history.push('');
    }

    render() {
        return (<>
                <div className={`modal-container ${this.props.className} ${this.props.relative ? "relative" : ""}`} >
                <div className="bg-hit" onClick={this.close} > </div> <div className="box" > {this.props.children} </div> </div>
            </>
        )
    }
}

export default withRouter(Modal);